<template>
    <div>
        <b-list-group v-for="cp in lista" :key="cp.Id" :flush="flush">
            <b-list-group-item href="#"><b>{{ cp.CargoEstablecimiento.CargoString }}</b>-{{ cp.CargoEstablecimiento.UnidadEducativaNivelString }}</b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
export default {
    name: 'CargoPersonalList',
    props: {
        lista: Array,
        flush: {
            default: true,
            type: Boolean
            }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/common/CargoPersonalList.vue